/**
 * Schedule condition node definition.
 * Converts active time intervals to indailyint format.
 */

import type { NodeDefinition } from '../types';
import type { FlowNode } from '../../../types/flow-types';

export const scheduleConditionDefinition: NodeDefinition = {
	type: 'scheduleCondition',
	category: 'condition',
	sourceHandles: ['true', 'false'],

	defaultData: () => ({
		label: 'Schedule',
		activeTimeIntervals: [],
	}),

	toSceneJson: (node: FlowNode) => {
		if (node.data.sceneData) {
			const sceneData = { ...(node.data.sceneData as any) };
			sceneData._fid = sceneData._fid || node.id;
			return sceneData;
		}
		return {
			indailyint: Array.isArray((node.data as any).activeTimeIntervals)
				? (node.data as any).activeTimeIntervals
				: [],
			_fid: node.id,
		};
	},
};
